module.exports = __webpack_public_path__ + "assets/img/mask-talent.a456c3ea.png";